/* ═══════════════════════════════════════════════════
   NEWJAISA — INDUSTRIAL & MANUFACTURING INDUSTRY PAGE
   File: assets/component-manufacturing.js
   Namespace: MfgPage · No globals · No jQuery
   Note: No FAQ · No scrollToCTA (no CTA section)
═══════════════════════════════════════════════════ */

'use strict';

var MfgPage = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  /* ── FORMAT INR ─────────────────────────── */
  function fmtINR(n) {
    if (n >= 10000000) return '₹' + (n / 10000000).toFixed(1) + ' Cr';
    if (n >= 100000)   return '₹' + (n / 100000).toFixed(1) + ' L';
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ── FLEET CAPEX CALCULATOR ─────────────── */
  function calcUptime() {
    var seatsEl = $('mfg-uc-seats');
    var typeEl  = $('mfg-uc-type');
    if (!seatsEl || !typeEl) return;

    var seats  = parseInt(seatsEl.value) || 0;
    var parts  = typeEl.value.split(',');
    var njPrice  = parseInt(parts[0]) || 20000;
    var newPrice = parseInt(parts[1]) || 48000;

    if (seats < 1) return;

    var disc     = seats >= 500 ? 0.15 : seats >= 100 ? 0.12 : seats >= 50 ? 0.08 : seats >= 10 ? 0.05 : 0;
    var njUnit   = Math.round(njPrice * (1 - disc));
    var njTotal  = njUnit * seats;
    var newTotal = newPrice * seats;
    var saving   = newTotal - njTotal;
    var pct      = Math.round((saving / newTotal) * 100);

    var njEl   = $('mfg-ucr-nj');
    var newEl  = $('mfg-ucr-new');
    var saveEl = $('mfg-ucr-save');
    var discEl = $('mfg-ucr-disc');

    if (njEl)   njEl.textContent   = fmtINR(njTotal);
    if (newEl)  newEl.textContent  = fmtINR(newTotal);
    if (saveEl) saveEl.textContent = fmtINR(saving) + ' · ' + pct + '%';

    if (discEl) {
      // if (disc > 0) {
      //   discEl.textContent  = '✓ ' + (disc * 100).toFixed(0) + '% volume discount applied';
      //   discEl.style.display = 'block';
      // } else {
      //   discEl.style.display = 'none';
      // }
    }
  }

  /* ── SCROLL REVEAL ──────────────────────── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      $$('.mfg-reveal').forEach(function (el) { el.classList.add('mfg-vis'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('mfg-reveal') && !el.classList.contains('mfg-vis');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('mfg-vis'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    $$('.mfg-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── GUIDE DOWNLOAD PLACEHOLDER ─────────── */
  function initDownloads() {
    var dlBtn = $('mfg-dl-guide');
    if (dlBtn) {
      dlBtn.addEventListener('click', function () {
        alert('Downloading: Industrial IT Procurement Guide\n\nContact business@newjaisa.com to receive the full guide.');
      });
    }
  }

  /* ── INIT ───────────────────────────────── */
  function init() {
    /* Calculator listeners */
    var seatsEl = $('mfg-uc-seats');
    var typeEl  = $('mfg-uc-type');
    if (seatsEl) seatsEl.addEventListener('input',  calcUptime);
    if (typeEl)  typeEl.addEventListener('change',  calcUptime);
    calcUptime();

    initReveal();
    initDownloads();
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  MfgPage.init();
});
